module.exports = __webpack_public_path__ + "9bf18dfa25424cf2334a68110f1b31d9.mp4";